import { captureWithSearchContext } from "./sentryScope";
class SearchTimeoutTracker {
    constructor() {
        this.timers = new Map();
    }
    // WI #8534 — `extraTags` (e.g., `{ OfferId }`) is forwarded to the Sentry
    // scope as top-level searchable tags. `traceId` is mapped to `SearchId` so
    // Sentry queries for `SearchId:<id>` surface the timeout events.
    start(name, traceId, warningMs = 20000, errorMs = 40000, extraTags) {
        this.cancel(name);
        const startTime = performance.now();
        const key = `${name}:${traceId}`;
        const warning = setTimeout(() => {
            captureWithSearchContext(`${name}: no response after ${warningMs / 1000}s`, "warning", {
                operation: name,
                step: "timeout-20s",
                tracker: "v3",
                SearchId: traceId,
                ...(extraTags !== null && extraTags !== void 0 ? extraTags : {}),
            });
        }, warningMs);
        const error = setTimeout(() => {
            const entry = this.timers.get(key);
            if (entry)
                entry.failed = true;
            captureWithSearchContext(`${name}: no response after ${errorMs / 1000}s — considered failed`, "error", {
                operation: name,
                step: "timeout-40s",
                tracker: "v3",
                SearchId: traceId,
                ...(extraTags !== null && extraTags !== void 0 ? extraTags : {}),
            });
        }, errorMs);
        this.timers.set(key, { warning, error, startTime, failed: false });
    }
    resolve(name, traceId) {
        const key = `${name}:${traceId}`;
        const entry = this.timers.get(key);
        if (!entry)
            return;
        clearTimeout(entry.warning);
        clearTimeout(entry.error);
        const elapsed = Math.round(performance.now() - entry.startTime);
        if (entry.failed) {
            captureWithSearchContext(`${name}: responded after ${elapsed}ms (after failure)`, "info", {
                operation: name,
                step: "recovered",
                elapsed: String(elapsed),
                tracker: "v3",
                SearchId: traceId,
            });
        }
        else if (elapsed > 20000) {
            captureWithSearchContext(`${name}: responded after ${elapsed}ms (late)`, "info", {
                operation: name,
                step: "late-response",
                elapsed: String(elapsed),
                tracker: "v3",
                SearchId: traceId,
            });
        }
        this.timers.delete(key);
    }
    cancel(name) {
        for (const [key, entry] of this.timers) {
            if (key.startsWith(`${name}:`)) {
                clearTimeout(entry.warning);
                clearTimeout(entry.error);
                this.timers.delete(key);
            }
        }
    }
}
export const searchTimeout = new SearchTimeoutTracker();
